import { AssetCategoryApi, AssetAreaApi, AssetApi } from "../../api/api"
import { AssetMgtPageLoaderBase } from "./index"
import { AssetCategoryPage, AssetAreaPage } from "../asset_item"
import { AssetBasicDataProvider } from "../asset_page_base"
/**
 * 頁面 /community/assetItem.aspx 執行此 Page loader
 */
export class AssetMgtItemLoader extends AssetMgtPageLoaderBase {

    private catPage: AssetCategoryPage
    private areaPage: AssetAreaPage

    private initCategories: Promise<void>
    private initAreas: Promise<void>
    constructor() {
        super()
        const assetApi = new AssetApi()
        const assetCategoryApi = new AssetCategoryApi()
        const assetAreaApi = new AssetAreaApi()
        const assetBasicDataProvider =  new AssetBasicDataProvider(assetCategoryApi, null, assetAreaApi)
        this.catPage = new AssetCategoryPage(assetApi, assetCategoryApi, assetBasicDataProvider)
        this.areaPage = new AssetAreaPage(assetApi, assetAreaApi, assetBasicDataProvider)
    }

    async load(): Promise<void> {
        this.initCategories = this.catPage.initCategories()
        this.initAreas = this.catPage.initAreas()
    }

    async loadOnDocumentReady(): Promise<void> {
        this.catPage.updateBackPageLink()
        this.catPage.listenCatEditClicks()
        this.catPage.listenCatSelectChange()
        this.catPage.listenCatAddClick()
        this.areaPage.listenAreaEditClicks()
        this.areaPage.listenAreaAddClick()
        //https://getbootstrap.com/docs/3.3/javascript/#tabs
        await Promise.all([this.initAreas, this.initCategories])
        this.catPage.refreshCategoryElms()
        this.areaPage.refreshAreaItemElms()
    }

}
